import React, { ReactNode, useEffect, useRef, useState } from "react"
import { CSSProperties } from "react"

interface AspectFitProps {
  aspectRatio: number
  children: ReactNode
  className?: string
  style?: CSSProperties
}

export default function AspectFit({ aspectRatio, className, style, children }: AspectFitProps) {
  const [parentAspectRatio, setParentAspectRatio] = useState<number | null>(null)

  const containerRef = useRef<HTMLDivElement>(null)

  function updateParentAspectRatio() {
    let parentNode = containerRef.current?.parentNode as HTMLDivElement
    if (!parentNode) return

    setParentAspectRatio(parentNode.clientWidth / parentNode.clientHeight)
  }

  useEffect(() => {
    updateParentAspectRatio()
    window.addEventListener("resize", updateParentAspectRatio)
    return () => window.removeEventListener("resize", updateParentAspectRatio)
  }, [])

  const getContainerStyle = () => {
    if (!containerRef.current) return {}

    let parentNode = containerRef.current.parentNode as HTMLElement
    if (!parentAspectRatio || !parentNode || !aspectRatio) {
      return {}
    }

    if (parentAspectRatio < aspectRatio) {
      let height = parentNode.clientWidth / aspectRatio
      return {
        width: "100%",
        height: height + "px",
        top: (parentNode.clientHeight - height) / 2 + "px"
      }
    } else {
      let width = parentNode.clientHeight * aspectRatio
      return {
        width: parentNode.clientHeight * aspectRatio + "px",
        height: "100%",
        left: (parentNode.clientWidth - width) / 2 + "px"
      }
    }
  }

  return <div
    ref={containerRef}
    style={{ ...getContainerStyle(), position: "relative", ...style }}
    className={className}
  >
    {children}
  </div>
}